/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = ['$scope'];

const SecurityManagerEmployeesHeaderController = function($scope) {

  const vm = this;

  vm.headerItems = [{
    name : 'Employee name',
    sortableParam : $scope.fullNameOrderParam
  }
  ,
    {name : 'Status'}
  ,
    {name : 'Last Active'}
  ,
    {name : 'Email'}
  ,
    {name : 'Address'}
  ,
    {name : 'Actions'}
  ];

  vm.toggleOrder = function(headerItem) {
    if (headerItem.sortableParam !== undefined) {
      return headerItem.sortableParam.ascending = !headerItem.sortableParam.ascending;
    }
  };

  vm.getClassName = function(headerItem) {
    if (headerItem.sortableParam === undefined) {
      return '';
    } else {
      let className = 'mod-sortable';
      if (headerItem.sortableParam.ascending) {
        className += ' mod-sortable-bottom';
      } else {
        className += ' mod-sortable-top';
      }
      return className;
    }
  };

  return vm;
};

angular.module('public.security-manager.hr.employees').controller('SecurityManagerEmployeesHeaderController',
  dependencies.concat(SecurityManagerEmployeesHeaderController));
